import storage from '@/utils/cache'
let { local: localCache } = storage

const persistRedirectParams = localCache.get('REDIRECTPARAMS') ? JSON.parse(localCache.get('REDIRECTPARAMS')) : ''

const routerHelp = {
  state: {
    redirectParams: persistRedirectParams,
  },

  mutations: {
    SET_REDIRECTPARAMS: (state, params) => {
      state.redirectParams = params
      localCache.set('REDIRECTPARAMS', JSON.stringify(params))
    },
  },
}

export default routerHelp